// src/features/competicao/competicaoCache.js
//
// Último placar da competição de equipes, guardado pelo card (offcanvas) e
// reusado por telas que não podem pagar uma chamada de Firestore só para
// mostrar um número — hoje, a animação de nível ("seus pontos: 1.240 → 1.303").
//
// A chave vive AQUI e não no card porque agora tem dois donos: quem escreve
// (TeamCompetitionCard) e quem lê (PublishButton, pelos handlers de registro).
// Duas cópias da mesma string em arquivos diferentes é o tipo de coisa que
// sobrevive a um rename e vira cache órfão.

export const CHAVE_CACHE_EQUIPES = 'teamCompetition_cache_v2';

/** Payload inteiro do getTeamCompetition guardado, ou null. */
export function lerCacheEquipes() {
  try {
    return JSON.parse(localStorage.getItem(CHAVE_CACHE_EQUIPES) || 'null');
  } catch {
    return null;
  }
}

/**
 * Meus pontos na competição, do último placar conhecido.
 *
 * Pode estar defasado — é cache. A animação usa este valor como PONTO DE
 * PARTIDA e soma o ganho que o servidor acabou de confirmar, então um número
 * velho faz o total exibido ficar velho, nunca o ganho errado. Sem cache
 * nenhum, devolve 0 e a animação começa do zero (que é honesto: é o primeiro
 * registro desde que o app conheceu a competição).
 *
 * @return {number}
 */
export function lerMeusPontos() {
  const cache = lerCacheEquipes();
  const pts = Number(cache?.myParticipant?.PTS);
  return Number.isFinite(pts) && pts > 0 ? pts : 0;
}
